import { Status } from '@/interfaces/status';
import { statusResource, StatusResource } from '@/resources/status.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł statusu
 *
 * @export
 * @class StatusModule
 * @extends {EntityModule<Status, StatusResource>}
 */
export class StatusModule extends EntityModule<Status, StatusResource> {
  constructor() {
    super(statusResource);
  }
}

export default new StatusModule();
